import {Component, OnInit, AfterViewInit, ViewChild, ElementRef, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MasterService} from '../../home/services/master.service';
import {CommonAlertService} from '../../services/common-alert.service';


@Component({
  selector: 'app-user-roles-modal',
  templateUrl: './user-roles-modal.component.html',
  styleUrls: ['./user-roles-modal.component.scss']
})
export class UserRolesModalComponent implements OnInit, AfterViewInit {
  public editOb: any;
  public editData: any;
  public title: string;
  public formData: any = {
    name: '',
    dashboard: {
      total_orders: false,
      available_stock: false,
      total_consumed: false,
      pending: false,
      today_stock: false,
      notification: false,
      implant_categories: false,
      products_used: false,
      order_stock: false,
      city: false
    },
    stock: {
      view: false,
      search:false
    },
    invoice: {
      view: false,
      add: false,
      edit: false,
      delete: false
    },
    purchase_order: {
      view: false,
      add: false,
      edit: false,
      delete: false
    },
    tracking: {
      view: false
    },
    scanned_implants:{
      view: false
    },
    active_implants:{
      view: false
    },
    accepted_implants:{
      view: false
    },
    rejected_implants:{
      view: false
    },
    missing_implants:{
      view: false
    },
    more: {
      body_parts: {
        view: false,
        add: false,
        edit: false,
        delete: false
      },
      implants: {
        view: false,
        add: false,
        edit: false,
        delete: false
      },
      products_categories: {
        view: false,
        add: false,
        edit: false,
        delete: false,
        approval: false
      },
      products: {
        view: false,
        add: false,
        edit: false,
        delete: false
      },
      regions: {
        view: false,
        add: false,
        edit: false,
        delete: false
      },
      countries: {
        view: false,
        add: false,
        edit: false,
        delete: false
      },
      cities: {
        view: false,
        add: false,
        edit: false,
        delete: false
      },
      stores: {
        view: false,
        add: false,
        edit: false,
        delete: false
      },
      antennas: {
        view: false,
        add: false,
        edit: false,
        delete: false
      },
      users: {
        view: false,
        add: false,
        edit: false,
        delete: false
      },
      users_roles: {
        view: false,
        add: false,
        edit: false,
        delete: false
      }
    },
    bulk_upload: {
      invoice: {
      upload: false,
    },
    rfid1: {
      upload: false,
    },
    rfid2: {
      upload: false,
    },
    purchase_order: {
      upload: false,
    },
    body_parts: {
      upload: false,
    },
    implants: {
      upload: false,
    },
    products_categories: {
      upload: false,
    },
    products: {
      upload: false,
    }
   },
   setting: {
     android: {
      view : false,
     },
     reports: {
      update : false,
      view : false,
     }
  }
  
  };
  public userRoletId: any;
  successMsg: any;
  public model = {
    user_role_id: ''
  } ;
  public editPermission = false;
  public addPermission = false;
  constructor(public dialogRef: MatDialogRef<UserRolesModalComponent>,
              public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
    if (data) {
      this.editOb = data;
    }
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.addPermission = this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['more.users_roles.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.users_roles.edit'] == 1) {
        this.editPermission = true;
      }
     }
    this.title = 'Add';
    if (this.editOb) {
      this.title = 'Edit';
      const id = this.editOb.id;
      // tslint:disable-next-line:variable-name
      const enc_id = this.editOb.enc_Id;
      this.masterService.getRecordById(id, enc_id, '/user_roles/get_data').subscribe(res => {
        // @ts-ignore
        this.editData = res.data;
        if (this.editData.roles.id) {
          this.formData.name = this.editData.roles.name;
          // tslint:disable-next-line:triple-equals
          this.formData.dashboard.total_orders = (this.editData.roles_item['dashboard.total_orders'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.dashboard.available_stock = (this.editData.roles_item['dashboard.available_stock'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.dashboard.total_consumed = (this.editData.roles_item['dashboard.total_consumed'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.dashboard.pending = (this.editData.roles_item['dashboard.pending'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.dashboard.today_stock = (this.editData.roles_item['dashboard.today_stock'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.dashboard.notification = (this.editData.roles_item['dashboard.notification'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.dashboard.implant_categories = (this.editData.roles_item['dashboard.implant_categories'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.dashboard.products_used = (this.editData.roles_item['dashboard.products_used'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.dashboard.order_stock = (this.editData.roles_item['dashboard.order_stock'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.dashboard.city = (this.editData.roles_item['dashboard.city'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.stock.view = (this.editData.roles_item['stock.view'] == 1);
          this.formData.stock.search = (this.editData.roles_item['stock.search'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.invoice.view = (this.editData.roles_item['invoice.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.invoice.add = (this.editData.roles_item['invoice.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.invoice.edit = (this.editData.roles_item['invoice.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.invoice.delete = (this.editData.roles_item['invoice.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.purchase_order.view = (this.editData.roles_item['purchase_order.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.purchase_order.add = (this.editData.roles_item['purchase_order.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.purchase_order.edit = (this.editData.roles_item['purchase_order.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.purchase_order.delete = (this.editData.roles_item['purchase_order.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.purchase_order.approval = (this.editData.roles_item['purchase_order.approval'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.tracking.view = (this.editData.roles_item['tracking.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.scanned_implants.view = (this.editData.roles_item['scanned_implants.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.active_implants.view = (this.editData.roles_item['active_implants.view'] == 1);
          this.formData.accepted_implants.view = (this.editData.roles_item['accepted_implants.view'] == 1);
          this.formData.rejected_implants.view = (this.editData.roles_item['rejected_implants.view'] == 1);
          this.formData.missing_implants.view = (this.editData.roles_item['missing_implants.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.body_parts.view = (this.editData.roles_item['more.body_parts.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.body_parts.add = (this.editData.roles_item['more.body_parts.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.body_parts.edit = (this.editData.roles_item['more.body_parts.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.body_parts.delete = (this.editData.roles_item['more.body_parts.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.implants.view = (this.editData.roles_item['more.implants.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.implants.add = (this.editData.roles_item['more.implants.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.implants.edit = (this.editData.roles_item['more.implants.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.implants.delete = (this.editData.roles_item['more.implants.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.products_categories.view = (this.editData.roles_item['more.products_categories.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.products_categories.add = (this.editData.roles_item['more.products_categories.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.products_categories.edit = (this.editData.roles_item['more.products_categories.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.products_categories.delete = (this.editData.roles_item['more.products_categories.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.products.view = (this.editData.roles_item['more.products.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.products.add = (this.editData.roles_item['more.products.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.products.edit = (this.editData.roles_item['more.products.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.products.delete = (this.editData.roles_item['more.products.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.regions.view = (this.editData.roles_item['more.regions.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.regions.add = (this.editData.roles_item['more.regions.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.regions.edit = (this.editData.roles_item['more.regions.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.regions.delete = (this.editData.roles_item['more.regions.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.countries.view = (this.editData.roles_item['more.countries.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.countries.add = (this.editData.roles_item['more.countries.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.countries.edit = (this.editData.roles_item['more.countries.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.countries.delete = (this.editData.roles_item['more.countries.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.cities.view = (this.editData.roles_item['more.cities.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.cities.add = (this.editData.roles_item['more.cities.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.cities.edit = (this.editData.roles_item['more.cities.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.cities.delete = (this.editData.roles_item['more.cities.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.stores.view = (this.editData.roles_item['more.stores.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.stores.add = (this.editData.roles_item['more.stores.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.stores.edit = (this.editData.roles_item['more.stores.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.stores.delete = (this.editData.roles_item['more.stores.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.antennas.view = (this.editData.roles_item['more.antennas.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.antennas.add = (this.editData.roles_item['more.antennas.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.antennas.edit = (this.editData.roles_item['more.antennas.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.antennas.delete = (this.editData.roles_item['more.antennas.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.users.view = (this.editData.roles_item['more.users.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.users.add = (this.editData.roles_item['more.users.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.users.edit = (this.editData.roles_item['more.users.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.users.delete = (this.editData.roles_item['more.users.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.users_roles.view = (this.editData.roles_item['more.users_roles.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.users_roles.add = (this.editData.roles_item['more.users_roles.add'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.users_roles.edit = (this.editData.roles_item['more.users_roles.edit'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.more.users_roles.delete = (this.editData.roles_item['more.users_roles.delete'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.bulk_upload.body_parts.upload = (this.editData.roles_item['bulk_upload.body_parts.upload'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.bulk_upload.implants.upload = (this.editData.roles_item['bulk_upload.implants.upload'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.bulk_upload.products_categories.upload = (this.editData.roles_item['bulk_upload.products_categories.upload'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.bulk_upload.products.upload = (this.editData.roles_item['bulk_upload.products.upload'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.bulk_upload.invoice.upload = (this.editData.roles_item['bulk_upload.invoice.upload'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.bulk_upload.purchase_order.upload = (this.editData.roles_item['bulk_upload.purchase_order.upload'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.bulk_upload.rfid1.upload = (this.editData.roles_item['bulk_upload.rfid1.upload'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.bulk_upload.rfid2.upload = (this.editData.roles_item['bulk_upload.rfid2.upload'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.setting.android.view = (this.editData.roles_item['setting.android.view'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.setting.reports.update = (this.editData.roles_item['setting.reports.update'] == 1);
          // tslint:disable-next-line:triple-equals
          this.formData.setting.reports.view = (this.editData.roles_item['setting.reports.view'] == 1);
        }
      });
    }
  }

  ngAfterViewInit() {

  }

  close() {
    this.dialogRef.close();
  }


  updateSize(more) {
    this.dialogRef.updateSize('80%', more);
  }

  submitForm(data) {

    if (this.editData) {
      this.userRoletId = this.userRoletId ? this.userRoletId : '';
      data.user_role_id = this.userRoletId;

      // tslint:disable-next-line:max-line-length variable-name
      const form_data = Object.assign(data, { id: this.editOb.id }, { enc_id: this.editOb.id }, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, '/user_roles/update').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });
    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/user_roles/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }
    this.close();
  }

}
